(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["star-scatter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__starScatterInit) return;
    window.__starScatterInit = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const OBSTACLES =
      'h1,h2,h3,h4,h5,h6,p,li,a,button,img,picture,video,iframe,input,select,textarea,label,svg:not(.star-scatter svg),[class*="price"],[class*="button"]';
    const GAP = 14;

    const hashSeed = (str) => {
      let h = 2166136261;
      for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }
      return h >>> 0;
    };

    const random = (seed) => {
      let s = seed;
      return () => {
        s = (s + 0x6d2b79f5) | 0;
        let t = Math.imul(s ^ (s >>> 15), 1 | s);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    };

    const overlaps = (a, b) =>
      a.left < b.right + GAP && a.right + GAP > b.left && a.top < b.bottom + GAP && a.bottom + GAP > b.top;

    const layout = (scatter) => {
      const host = scatter.closest('.shopify-section') || scatter.parentElement;
      if (!host) return;
      // Positions are relative to the star layer itself, which fills its positioned ancestor.
      const hostRect = scatter.getBoundingClientRect();
      if (!hostRect.width || !hostRect.height) return;

      const obstacles = [];
      host.querySelectorAll(OBSTACLES).forEach((el) => {
        if (scatter.contains(el)) return;
        const r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) return;
        obstacles.push({
          left: r.left - hostRect.left,
          right: r.right - hostRect.left,
          top: r.top - hostRect.top,
          bottom: r.bottom - hostRect.top,
        });
      });

      const isMobile = window.innerWidth < 750;
      const scale = isMobile ? 0.65 : 1;
      const min = Number(scatter.dataset.min) * scale;
      const max = Math.max(min, Number(scatter.dataset.max) * scale);
      const colours = (scatter.dataset.colours || '').split(',');
      const rand = random(hashSeed(scatter.dataset.seed + (isMobile ? 'm' : 'd')));
      const placed = [];

      scatter.querySelectorAll('[data-star]').forEach((star, index) => {
        let spot = null;
        for (let attempt = 0; attempt < 80 && !spot; attempt++) {
          const size = Math.round(min + rand() * (max - min));
          const x = 6 + rand() * Math.max(0, hostRect.width - size - 12);
          const y = 6 + rand() * Math.max(0, hostRect.height - size - 12);
          const box = { left: x, right: x + size, top: y, bottom: y + size };
          if (box.right > hostRect.width || box.bottom > hostRect.height) continue;
          if (obstacles.some((o) => overlaps(box, o))) continue;
          if (placed.some((p) => overlaps(box, p))) continue;
          spot = { ...box, size };
        }

        if (!spot) {
          star.classList.remove('is-placed');
          star.style.display = 'none';
          return;
        }

        placed.push(spot);
        star.style.display = '';
        star.style.width = `${spot.size}px`;
        star.style.height = `${spot.size}px`;
        star.style.color = colours[index % colours.length] || colours[0];
        star.style.setProperty('--x', `${spot.left.toFixed(1)}px`);
        star.style.setProperty('--y', `${spot.top.toFixed(1)}px`);
        star.style.setProperty('--tilt', `${Math.round(rand() * 60 - 30)}deg`);
        star.dataset.direction = rand() > 0.5 ? '1' : '-1';
        star.dataset.speed = (0.12 + rand() * 0.2).toFixed(3);
        star.dataset.driftRange = Math.round(Math.min(10, spot.size * 0.15));
        star.classList.add('is-placed');
      });
    };

    const layoutAll = () => document.querySelectorAll('[data-star-scatter]').forEach(layout);

    let ticking = false;
    const animate = () => {
      ticking = false;
      const motion = !reduceMotion.matches;
      const viewport = window.innerHeight;
      document.querySelectorAll('[data-star-scatter]').forEach((scatter) => {
        const rect = scatter.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewport + 200) return;
        const rotate = scatter.dataset.rotate === 'true';
        const drift = scatter.dataset.drift === 'true';
        const progress = (viewport - rect.top) / (viewport + rect.height);
        scatter.querySelectorAll('[data-star].is-placed').forEach((star) => {
          const dir = Number(star.dataset.direction) || 1;
          const speed = Number(star.dataset.speed) || 0.2;
          const range = Number(star.dataset.driftRange) || 6;
          star.style.setProperty('--spin', motion && rotate ? `${(progress * 360 * speed * 3 * dir).toFixed(1)}deg` : '0deg');
          star.style.setProperty('--drift', motion && drift ? `${((progress - 0.5) * range * 2 * dir).toFixed(1)}px` : '0px');
        });
      });
    };
    const requestAnimate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(animate);
    };

    let resizeTimer;
    const relayout = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        layoutAll();
        requestAnimate();
      }, 150);
    };

    window.addEventListener('scroll', requestAnimate, { passive: true });
    window.addEventListener('resize', relayout);
    window.addEventListener('load', relayout);
    reduceMotion.addEventListener('change', requestAnimate);
    document.addEventListener('shopify:section:load', relayout);
    document.addEventListener('shopify:block:select', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(relayout);
      const watch = () =>
        document.querySelectorAll('[data-star-scatter]').forEach((s) => {
          const host = s.closest('.shopify-section');
          if (host) observer.observe(host);
        });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
      else watch();
    }
    relayout();
  })();
  } catch(e) { console.error(e); }
})();

})();
